module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-35.11034866.jpg";